import { holdingBuyValueTotal, portfolioHoldingValueTotal } from "./investmentPricing";

function pnlMeta(unrealizedPnl, buyValue) {
  const pnlTone = unrealizedPnl > 0.01 ? "profit" : unrealizedPnl < -0.01 ? "loss" : undefined;
  const unrealizedReturnPct = buyValue > 0 ? (unrealizedPnl / buyValue) * 100 : null;
  const unrealizedReturnHint =
    unrealizedReturnPct != null
      ? `${unrealizedReturnPct >= 0 ? "+" : ""}${unrealizedReturnPct.toFixed(3)}% return`
      : "—";
  return { pnlTone, unrealizedReturnHint };
}

/**
 * Summary cards for My Portfolio totals (Portfolio / Invested / P&L / Redeemed).
 */
export function buildPortfolioSummaryMetrics({
  holdings = [],
  redemptionBalances = [],
  moneyValue,
  formatShare,
}) {
  const holdingsWithShares = holdings.filter((h) => Number(h.shares_held) > 0);
  let shares = 0;
  let estValue = 0;
  let buyValue = 0;
  for (const h of holdingsWithShares) {
    const n = Number(h.shares_held) || 0;
    const p = h.project;
    shares += n;
    buyValue += holdingBuyValueTotal(h);
    estValue += portfolioHoldingValueTotal(h, p);
  }
  const unrealizedPnl = estValue - buyValue;
  const { pnlTone, unrealizedReturnHint } = pnlMeta(unrealizedPnl, buyValue);

  let locked = 0;
  let redeemed = 0;
  for (const b of redemptionBalances) {
    locked += Number(b.shares_pending_redemption || 0);
    redeemed += Number(b.shares_redeemed_total || 0);
  }

  return [
    {
      key: "value",
      icon: "portfolio",
      label: "Portfolio",
      value: moneyValue(estValue),
      accent: "blue",
      hint: `Projects Holding ${holdingsWithShares.length}`,
    },
    {
      key: "cost",
      icon: "cost",
      label: "Invested",
      value: moneyValue(buyValue),
      accent: "green",
      hint: `${formatShare(shares)} shares held`,
    },
    {
      key: "pnl",
      icon: "pnl",
      label: "P&L",
      value: moneyValue(Math.abs(unrealizedPnl), unrealizedPnl >= 0 ? "+" : "-"),
      accent: pnlTone === "loss" ? "red" : "green",
      hint: unrealizedReturnHint,
      tone: pnlTone,
    },
    {
      key: "redeemed",
      icon: "redeemed",
      label: "Redeemed",
      value: formatShare(redeemed),
      accent: "blue",
      hint: `Pending ${formatShare(locked)}`,
    },
  ];
}
